import { RetryLink } from "@apollo/client/link/retry";

const retryLink = new RetryLink({
  attempts: {
    max: 10,
    retryIf: (error) => {
      if (!error || !("statusCode" in error)) return false;
      const status = error.statusCode;
      if (status === 401) return false;
      return status >= 500 || status === 429 || status === 408;
    },
  },
  delay: {
    initial: 500,
    max: 10000,
    jitter: true,
  },
});

export default retryLink;
